import PaymentValueObjectsFactory from '../ValueObjects/factory.js'
import PriceRawDataToPriceVOMapper from './PriceRawDataToPriceVOMapper.js'
import TaxRawDataToTaxVOMapper from './TaxRawDataToTaxVOMapper.js'

export default class PaymentMappersFactory {
  static priceRawDataToPriceVOMapper = () =>
    new PriceRawDataToPriceVOMapper({
      valueObject: PaymentValueObjectsFactory.priceValueObject
    })

  static taxRawDataToTaxVOMapper = () =>
    new TaxRawDataToTaxVOMapper({
      valueObject: PaymentValueObjectsFactory.taxValueObject
    })
}
